import type { Order } from '@shared-types/common.types';
import type { Draw } from '@shared-types/draw.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, drawApiUrl } from '@utilities/WindowContext';

export const fetchDraws = async (
  params: {
    drawId?: string;
    competitionId: string;
    seasonYear: string;
    optionalFields?: string | string[];
    order?: Order;
  },
  signal?: AbortSignal,
) => (await loadFromAPIs<Draw[]>('v1/draws', params, { apiKey, apiUrl: drawApiUrl, signal })) ?? [];

export const fetchDraw = (params: { drawId: string; optionalFields?: string | string[] }, signal?: AbortSignal) =>
  loadFromAPIs<Draw[]>('v1/draws', params, { apiKey, apiUrl: drawApiUrl, signal }).then((data) => data?.[0] ?? null);
